import { ContractingStateEnum } from 'v3/data/store/contracting/enums';

type MappingValue = {
  name: string;
  title: string;
};

type ContractingStateMappingType = Record<ContractingStateEnum, MappingValue>;

export const ContractingStateMapping: ContractingStateMappingType = {
  CONTRATACAO_INICIADA: {
    name: 'ContratacaoIniciada',
    title: 'Contratação Iniciada',
  },
  PROCESSANDO_ANALISE_CREDITO: {
    name: 'ProcessandoAnaliseCredito',
    title: 'Processando Análise de Crédito',
  },
  ANALISE_CREDITO_REPROVADA: {
    name: 'AnaliseCreditoReprovada',
    title: 'Análise de Crédito Reprovada',
  },
  AGUARDANDO_GERACAO_PROPOSTA: {
    name: 'AguardandoGeracaoProposta',
    title: 'Aguardando Geração de Proposta',
  },
  AGUARDANDO_DOCUMENTOS: {
    name: 'AguardandoDocumentos',
    title: 'Aguardando Documentos',
  },
  AGUARDANDO_SELFIE: {
    name: 'AguardandoSelfie',
    title: 'Aguardando Selfie',
  },
  CAF_REPROVADA: {
    name: 'CafReprovada',
    title: 'CAF Reprovada',
  },
  AGUARDANDO_DADOS_CADASTRAIS: {
    name: 'AguardandoDadosCadastrais',
    title: 'Aguardando Dados Cadastrais',
  },
  AGUARDANDO_ACEITES_TERMOS: {
    name: 'AguardandoAceiteTermos',
    title: 'Aguardando Aceite dos Termos',
  },
  PROCESSANDO_ANTIFRAUDE: {
    name: 'ProcessandoAntifraude',
    title: 'Análise de documento em andamento',
  },
  AGUARDANDO_EFETIVACAO_CONTRATO: {
    name: 'AguardandoEfetivacaoContrato',
    title: 'Aguardando Efetivação do Contrato',
  },
  CONTRATACAO_FINALIZADA: {
    name: 'ContratacaoFinalizada',
    title: 'Contratação Finalizada',
  },
  AGUARDANDO_ACEITE_PROPOSTA: {
    name: 'AguardandoAceiteProposta',
    title: 'Aguardando Aceites da Proposta',
  },
  CPF_BLOQUEADO: {
    name: 'CpfBloqueado',
    title: 'CPF Bloqueado',
  },
  CONTRATACAO_NEGADA: {
    name: 'ContratacaoNegada',
    title: 'Contratação Negada',
  },
  CHAVE_EXPIRADA: {
    name: 'ChaveExpirada',
    title: 'Chave Expirada',
  },
};
